<template>
  <div v-if="blog && blog.files">
    <ui-select
      v-model="blog.image_id"
      label="Blog image"
      >
      <ui-select-option
        v-for="(name,id) in computedSelectableFiles"
        :key="id"
        :value="id"
        :text="name"
        :default="blog?.image?.name == name"
        />
    </ui-select>

    <div class="flex justify-end py-2">
      <ui-button
        class="dark"
        text="Create new blog image"
        @click="() => {
          if (!blog) {
            notify({
              text: 'Blog not found',
              type: 'error',
            })
            return;
          }

          ws.send('blog.newimage',{id: blog.id})

          notify('Generation started. Result will show in more than a minute')

        }"
        />
    </div>

    <div v-if="blog.files.length" class="flex flex-wrap gap-2">
      <UiFileWidget
        v-for="(file,i) in blog.files"
        :key="file.id"
        :model-value="(blog.files[i] as File)"
        :selected="blog.image_id == file.id"
        @click="blog.image_id = (blog.image_id == file.id) ? null : file.id"
        />
    </div>
    <div v-else class="flex items-center justify-center p-8 text-gray-600">
      <span>No files found</span>
    </div>
  </div>
</template>

<script setup lang="ts">
const blog = defineModel<Blog>()

onMounted(() => {
  if(!blog.value || !blog.value?.id) return;

  methodLoadBlogFiles(blog.value?.id).then((files) => {
    if(!blog.value) return;
    blog.value.files = files
  })
})

const computedSelectableFiles = computed(() => {
  return blog.value?.files?.reduce((acc: Record<string,string>, file: any) => {
    acc[file.id] = file.name

    return acc
  }, {} as Record<string,string>)
})

watch(() => blog, (b) => {
  if(!b || !blog.value) return;
  blog.value.files = blog.value?.files || []
})
</script>
